import React, { Component } from 'react';
import { imageBasePath } from '../../constants/staticData';

export default class MessageEmptyState extends Component {

    render() {
        return (
            <div >
                <div className="empty-state-holder">
                    <span className="empty-state-content">
                        <img src={`${imageBasePath}/images/messages_empty.png`} alt="" />
                        <span className="text">Oops! Looks like you don’t have any messages yet. </span>
                    </span>
                </div>
            </div>
        );
    }
}
